import baseAPI from "../api";
import { Profile } from "./profileModel";

export function getProfileRequest(profileId: Profile["id"]): Promise<Profile> {
  return baseAPI.get(`/profiles/${profileId}`).then(({ data }) => data);
}

export function getAllProfilesRequest(): Promise<Profile[]> {
  return baseAPI.get("/profiles").then(({ data }) => data);
}

export function getProfilesByUidRequest(
  profileUid: Profile["uid"],
): Promise<Profile> {
  return baseAPI.get(`/profiles/uid/${profileUid}`).then(({ data }) => data);
}

export function getEmbedProfileByUidRequest(
  profileUid: Profile["uid"],
): Promise<Profile> {
  return baseAPI
    .get(`/profiles/embed/uid/${profileUid}`)
    .then(({ data }) => data);
}

export function createProfileRequest(
  data: Pick<Profile, "name">,
): Promise<Profile> {
  return baseAPI.post("/profiles", data).then(({ data }) => data);
}

export function updateProfileRequest(
  id: Profile["id"],
  data: Partial<Profile>,
): Promise<Profile> {
  return baseAPI.put(`/profiles/${id}`, data).then(({ data }) => data);
}

export function deleteProfileRequest(id: Profile["id"]): Promise<void> {
  return baseAPI.delete(`/profiles/${id}`);
}

export function createProfileUploadLinkRequest(
  profileId: Profile["id"],
): Promise<{ uploadLink: string; uploadId: string }> {
  return baseAPI.post(`/profiles/${profileId}/upload`).then(({ data }) => data);
}

export function generateProfileCoverLetterRequest(
  profileId: Profile["id"],
  qrCode: string,
): Promise<string> {
  return baseAPI
    .post(
      `/profiles/${profileId}/cover-letter`,
      {
        qrCode,
      },
      {
        responseType: "blob",
      },
    )
    .then(({ data }) => data);
}

export function getProfileCoverLetterRequest(
  profileId: Profile["id"],
): Promise<string> {
  return baseAPI
    .get(`/profiles/${profileId}/cover-letter`, { responseType: "blob" })
    .then(({ data }) => data);
}

export function notifyUploadSuccessRequest(
  profileId: Profile["id"],
  uploadId: string,
  thumbnail?: string,
): Promise<void> {
  return baseAPI.post(`/profiles/${profileId}/notify-upload-success`, {
    uploadId,
    thumbnail,
  });
}

export function notifyProfileUploadErrorRequest(
  profileId: Profile["id"],
  uploadId?: string,
): Promise<void> {
  return baseAPI.post(`/profiles/${profileId}/notify-upload-error`, {
    uploadId,
  });
}
